import Player from 'components/BottomBar/Player';
function Bottombar(){
    return (
        <div className="h-24 bg-footer border-t border-white border-opacity-5">
            <Player />
        </div>
    )
}
export default Bottombar;